import BookManagement from "./book-management.page";

export default BookManagement;
